/**
 * Unique identifier for the ProofsPages feature group.
 */
export const PROOFS_PAGES_FEATURE_GROUP_ID = "PROOFS_PAGES_FEATURE_GROUP";
